var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01594 13.2308C0.937763 13.4653 1.16088 13.6884 1.39541 13.6102L3.8262 12.8L1.8262 10.8L1.01594 13.2308ZM4.56069 12.1869L13.1869 3.56066C13.7727 2.97487 13.7727 2.02513 13.1869 1.43934C12.6011 0.853554 11.6513 0.853553 11.0656 1.43934L2.43937 10.0655L4.56069 12.1869Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.41b099e8da05fc570381e7710f6fb311.svg";
export { ForwardRef as ReactComponent };